<mat-form-field class="mutara-infix" [appearance]="props?.appearance">
   <mat-label [title]="props.label" [for]="field.id + '_label'">{{props.label}} {{props.isRequired ? '*' : ''}}</mat-label>
   <input title='{{props.label}}' matInput #inputField [ngClass]="['flex-full']" [disabled]='props?.readonly || props.disabled' type='text'
      [id]="field.id + '_label'" [placeholder]="props.placeholder" [matAutocomplete]='optionList'>
   <mat-autocomplete [class]=="{{field?.className ?? 'mutara-infix'}}" #optionList='matAutocomplete' [panelWidth]="'auto'"
      (optionSelected)='valueChange($event)'>
      @if ( !!groupNames ) {
      @for (group of groupNames; track group ) {
      <mat-optgroup [label]="group">
         @for ( option of optionsToDisplay[group]; track option.value ) {
         <mat-option [value]="option.value">{{option.label}}</mat-option>
         }
      </mat-optgroup>
      }
      }
      @else {
      @for ( option of optionsToDisplay['']; track option.value ) {
      <mat-option [value]="option.value">{{option.label}}</mat-option>
      }
      }
   </mat-autocomplete>
   @if (!!props.description) {
   <mat-hint [class]='props.hintClass'>{{props.description}}</mat-hint>
   }
</mat-form-field>